import { useSearchParams } from "react-router-dom";
import { CostStatistics, CreateCost, IncomeControlPanel, OperatorIncome, OperatorModems, QueryParamsManagerCosts, QueryParamsManagerDashboard, TableCost, TabsNavigate, TotalAmounts } from "./components";
import style from "./StatisticsPage.module.scss";
import cn from "classnames";
import { dashboardQueryOptions, useGetAllOperatorsIncomeQuery, useGetLiveStatisticQuery } from "@RTKQuery/admin/dashboard/dashboard";
import { useAppSelector } from "store/hooks";
import { AnalyticsStatus } from "./components/AnalyticsStatus/AnalyticsStatus";

export function StatisticsPage() {
  const [queryParams] = useSearchParams();

  return (
    <main className={style.page}>
      <TabsNavigate />
      {
        queryParams.get("tab") === "dashboard"
          ? <>
            <OperatorModemsList />
            <IncomeControlPanel />
            <OperatorIncomeList />
            <div className={cn(style.flexBox, "!mb-0 ")}>
              <CostStatistics />
              <TotalAmounts />
            </div>
            <QueryParamsManagerDashboard />
          </>
          : null
      }
      {
        queryParams.get("tab") === "costs"
          ? <>
            <CreateCost />
            <TableCost />
            <QueryParamsManagerCosts />
          </>
          : null
      }
    </main>
  );
}

function OperatorModemsList() {
  const { currentData: data, isError, refetch } = useGetLiveStatisticQuery(void 0, dashboardQueryOptions);

  if (isError) return <AnalyticsStatus error message="Не вдалося завантажити стан модемів." retry={refetch} />;
  if (!data) return <AnalyticsStatus message="Завантаження стану модемів…" />;

  return (
    <div className={style.flexBox}>
      {
        data?.map(item => (
          <OperatorModems key={item.operator} data={item} />
        ))
      }
    </div>
  )
}

function OperatorIncomeList() {
  const { activeEndDate, activeStartDate } = useAppSelector(state => state.dashboardAdminPage);

  const { currentData: data, isError, refetch } = useGetAllOperatorsIncomeQuery({
    end_date: activeEndDate,
    start_date: activeStartDate
  }, dashboardQueryOptions);

  if (isError) return <AnalyticsStatus error message="Не вдалося завантажити покупки." retry={refetch} />;
  if (!data) return <AnalyticsStatus message="Завантаження покупок…" />;
  if (!data.length) return <AnalyticsStatus message="За вибраний період покупок немає." />;

  return (
    <div className={style.flexBox}>
      {
        data?.map(item => (
          <OperatorIncome key={item.operator} data={item} />
        ))
      }
    </div>
  )
}
